<template>
  <div id="financialStatistics">
    <div>
      <h1 class="financialTtitle">{{ $t('financialStatistics.header.title') }}</h1>
      <div class="financialHeaderBox">
        <span class="outputField">{{ $t('financialStatistics.header.export') }}</span>
        <p @click="outputType('0')" class="csvPdfField">
          <span>CSV</span>
          <span class="csvPdfLine"></span>
        </p>
        <p @click="outputType('1')" class="csvPdfField">
          <span>PDF</span>
          <span class="csvPdfLine"></span>
        </p>
      </div>
    </div>

    <div style="display:flex;justify-content: space-between;">
      <div class="_div">
        <ul class="_ul">
          <li
            @click="clickLiColor('0', 'week')"
            :class="{ liBackColor: isLiBackColor === '0' }"
          >過去 7 天</li>
          <li
            @click="clickLiColor('1', 'month')"
            :class="{ liBackColor: isLiBackColor === '1' }"
          >過去 30 天</li>
          <li
            @click="clickLiColor('2', 'year')"
            :class="{ liBackColor: isLiBackColor === '2' }"
          >過去 1 年</li>
          <li>
            <div class="block" :class="{blockChose: ischoose === true}">
              <el-date-picker
                v-model="value6"
                format="MM月dd日"
                :type="daterange"
                @focus="pickerFunc"
                @blur="blurFunc"
                ref="picker"
                :editable="false"
              ></el-date-picker>
            </div>
          </li>
        </ul>
      </div>

      <div style="display: flex;line-height: 60px;">
        <span>{{ $t('financialStatistics.header.fenrun') }}</span>
        <p>
          <span class="pulicWeight">&nbsp;&nbsp;7</span>
          <span>（{{ $t('common.you') }}）</span>
        </p>
        <span>:&nbsp;</span>
        <p>
          <span class="pulicWeight">3</span>
          <span>（Nuwa）</span>
        </p>
      </div>
    </div>

    <div class="centerTopBox">
      <div class="centerTopBoxSmall">
        <div>
          <h1 class="sumQuantityTitle">{{ $t('financialStatistics.box.sales') }}</h1>
          <p>
            <span>NTD</span>
            <span class="sumQuantityNum">10,000,000.00</span>
          </p>
        </div>
        <div style="margin-top: 14px;">
          <h1 class="sumQuantityTitle">{{ $t('financialStatistics.box.money') }}</h1>
          <p>
            <span>NTD</span>
            <span class="sumQuantityNum">10,000,000.00</span>
          </p>
        </div>

        <div class="centerTopBoxSmallBottom">
          <div>
            <h1 class="csGrapgicTitleIncome">{{ $t('financialStatistics.box.money') }}</h1>
            <div class="rectangle">
              <TotalSales :totalData="totalData"/>
            </div>
          </div>
          <div>
            <h1 class="csGrapgicTitleIncome">{{ $t('financialStatistics.box.top5.money') }}</h1>
            <div class="rectangle">
              <TopSales :topData="topData"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottomBox">
      <div class="bottomBoxInput">
        <div class="inpu_div">
          <el-input v-model="search" size="mini" class="_input" :placeholder="$t('table.common.search.placeholder')"/>
          <i class="_sprite_class" @click="searchClick"></i>
        </div>
        <span>{{total}}{{ $t('financialStatistics.table.total') }}</span>
      </div>

      <el-main style="width: 100.4%;">
        <el-table
          ref="dataTable"
          v-loading="loading"
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          style="width: 99.8%"
        >
          <el-table-column width="91px;" prop="icon">
            <template slot-scope="scope">
              <img :src="scope.row.icon" alt class="tableIconClass">
            </template>
          </el-table-column>

          <el-table-column :label="$t('table.common.projectName')" width="137px;" prop="projectName">
            <template slot-scope="scope">
              <div style="line-height:90px;">
                <span>{{scope.row.projectName}}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            :default-sort="{prop: 'contentType', order: 'descending'}"
            sortable
            :label="$t('table.common.projectType')"
            width="134px;"
            prop="contentType"
          ></el-table-column>

          <el-table-column :label="$t('financialStatistics.table.header.price')" width="95px;" prop="price"></el-table-column>
          <el-table-column
            :default-sort="{prop: 'count', order: 'ascending'}"
            sortable
            width="95px;"
            :label="$t('financialStatistics.table.header.number')"
            prop="count"
          ></el-table-column>
          <el-table-column :label="$t('financialStatistics.table.header.subtotal')" width="95px;" prop="sum"></el-table-column>
          <el-table-column
            :default-sort="{prop: 'ratio', order: 'descending'}"
            sortable
            :label="$t('financialStatistics.table.header.proportion')"
            width="95px;"
            prop="ratio"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.ratio ? scope.row.ratio + '%' : '--'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :default-sort="{prop: 'increaseRate', order: 'descending'}"
            sortable
            :label="$t('financialStatistics.table.header.grow')"
            prop="increaseRate"
          >
            <template slot-scope="scope">
              <div>
                <el-tooltip transition="el-fade-in" popper-class="financialTooltipItem" effect="light" placement="bottom">
                    <div slot="content">
                        <p>
                            <span>{{ toolTipMoment('beg', scope.row.beg) }} - </span>
                            <span>{{ toolTipMoment('end', scope.row.end) }}</span>
                        </p>
                    </div>
                    <span
                    class="increaseRateClass"
                    :class=" increaseRateStyle(scope) "
                    >{{ increaseRateText(scope) }}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </div>
  </div>
</template>
<style scoped>
h1,
p,
ul {
    margin: 0px;
    padding: 0px;
}
/* publicStyle */
#financialStatistics {
    width: 897px;
    margin: auto;
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.9px;
    color: #333333;
    padding-bottom: 100px;
}

/* 新增 */
.tableIconClass {
    width: 60px;
    height: 60px;
    vertical-align: middle;
    display: inline-block;
    padding: 15px 10px;
}
.unScroll {
    overflow: hidden;
}
.scrollShow {
    overflow: scroll;
    overflow-x: hidden;
}
.toolTipBox {
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(0, 0, 0, 0.15);
    position: absolute;
    /* top: 0px;
    left: 0px; */
    background: #ffffff;
    z-index: 1;
    padding: 0px 5px 5px 5px;
    border-radius: 4px;
    visibility: hidden;
}
.rightBoxA {
    width: 0;
    height: 0;
    border-width: 0 6px 6px;
    border-style: solid;
    border-color: transparent transparent rgba(51, 51, 51, 0.2);
    margin: 0px auto;
    position: absolute;
    top: -6px;
    left: 46%;
}
.rightBoxAClone {
    width: 0;
    height: 0;
    border-width: 5px 5px 0;
    border-style: solid;
    border-color: rgba(51, 51, 51, 0.2) transparent transparent; /*灰 透明 透明 */
    margin: 0px auto;
    position: absolute;
    bottom: -6px;
    left: 46%;
}
.rightBox {
    width: 0;
    height: 0;
    border-width: 0 5px 5px;
    border-style: solid;
    border-color: transparent transparent #fff;
    margin: 0px auto;
    top: -5px;
    position: absolute;
    left: 47%;
    z-index: 3;
}
.rightBoxClone {
    width: 0;
    height: 0;
    border-width: 5px 5px 0;
    border-style: solid;
    border-color: #fff transparent transparent; /*灰 透明 透明 */
    margin: 0px auto;
    bottom: -5px;
    position: absolute;
    left: 46%;
    z-index: 3;
}
.visibilityClass {
    visibility: visible;
}
.maskDivClass {
    width: 100%;
    height: 10px;
    position: absolute;
    /* margin: auto; */
    top: -10px;
    margin-left: -5px;
}
.toolTipBoxText {
    /* width: 150px; */
    /* height: 37px; */
    font-size: 12px;
    line-height: 1.67;
    letter-spacing: normal;
    font-weight: normal;
    text-align: center;
    padding: 5px 0px;
}
/* 新增 */
.increaseRateClass {
    width: 75px;
    text-align: center;
    height: 25px;
    border: 1px solid;
    line-height: 25px;
    border-radius: 4px;
    display: inline-block;
    background-color: rgba(51, 51, 51, 0.1);
    color: #333333;
    box-sizing: border-box;
    border-color: rgba(51, 51, 51, 0.3);
}
.increaseRateClassPositive {
    color: #00b5e2;
    border-color: #00b5e2;
    background-color: rgba(0, 181, 226, 0.1);
}
.increaseRateClassNegative {
    color: #ffc44f;
    border-color: #ffc44f;
    background-color: rgba(255, 196, 79, 0.1);
}
.financialTtitle {
    /* width: 254px; */
    height: 59px;
    font-size: 40px;
    font-weight: 500;
    letter-spacing: 2.2px;
    margin-top: 14px;
}
.financialHeaderBox {
    display: flex;
    line-height: 30px;
    justify-content: flex-end;
}
.outputField {
    width: 34px;
    height: 24px;
    font-size: 16px;
}

.csvPdfField > span:first-child{
    display: block;
    width: 100%;
    height: 100%;
}
.csvPdfField > span:first-child:hover{
    display: block;
    width: 100%;
    height: 100%;
    margin-top: -2px;
}
.csvPdfField {
    width: 75px;
    height: 30px;
    border-radius: 10px;
    background-color: #bef1ef;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 1px;
    text-align: center;
    color: #00b5e2;
    line-height: 30px;
    cursor: pointer;
    margin-left: 20px;
    position: relative;
}
.csvPdfLine {
    width: 57px;
    height: 1px;
    background: rgba(51, 51, 51, 0.3);
    position: absolute;
    bottom: 0px;
    left: 8px;
}
.pulicWeight {
    font-weight: 500;
}
.sumQuantityTitle {
    /* width: 68px; */
    height: 24px;
    font-size: 16px;
    font-weight: 500;
}
.sumQuantityNum {
    width: 404px;
    height: 59px;
    font-size: 40px;
    font-weight: 500;
    letter-spacing: 2.2px;
    vertical-align: sub;
}
.centerTopBox {
    width: 897px;
    height: 537px;
    border: 1px solid rgba(51, 51, 51, 0.2);
    border-radius: 4px;
    border-top-left-radius: unset;
}
.centerTopBoxSmall {
    width: 716px;
    margin: auto;
    padding: 25px 0px 50px 0px;
}
.csGrapgicTitleIncome {
    height: 24px;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 14px;
}
.rectangle {
    width: 350px;
    height: 219px;
    outline: 1px solid#d8d8d8;
}
.centerTopBoxSmallBottom {
    display: flex;
    justify-content: space-between;
    margin-top: 36px;
}
.bottomBox {
    margin-top: 21px;
}
.inpu_div {
    display: inline-block;
    /* width: 200px; */
    /* margin-left: 30px; */
    position: relative;
}
._input {
    width: 166px;
    border-radius: 3px;
    outline: none !important;
}

._sprite_class {
    display: inline-block;
    width: 14px;
    height: 14px;
    background-image: url('../../assets/img/header/filter_search_icon.png');
    position: absolute;
    left: 10px;
    top: 7px;
    cursor: pointer;
    text-align: center;
    background-size: 100%;
}
.bottomBoxInput {
    display: flex;
    justify-content: space-between;
    margin-bottom: 14px;
}
/* pickerDate */
._div {
    text-align: right;
    display: flex;
    line-height: 40px;
    justify-content: space-between;
    margin-top: 20px;
}
._ul li {
    width: 111px;
    height: 40px;
    background-color: #ffffff;
    border: 1px solid rgba(51, 51, 51, 0.2);
    border-right: none;
    line-height: 40px;
    cursor: pointer;
    display: inline-block;
    text-align: center;
    border-bottom: none;
}
._ul li:nth-child(1) {
    border-top-left-radius: 4px;
    /* border-bottom-left-radius: 4px; */
}
._ul li:nth-child(4) {
    border-left: none;
    border-top: none;
}
#financialStatistics .liBackColor {
    /* background-color: #00b5e2; */
    /* color: #ffffff; */
    font-weight: 500;
    line-height: 39px;
}
.block {
    width: 111px;
    position: relative;
    right: 0px;
}
.blockChose {
    width: 205px;
}
</style>
<style>
.financialTooltipItem {
    padding: 6px!important;
    border: 1px solid #d6d6d6!important;
    text-align: center;
    -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
    letter-spacing: 0.7px;
    color: rgba(51, 51, 51, 0.8);
    font-weight: 300;
}
.financialTooltipItem .popper__arrow {
    border-top-color: #d6d6d6!important;
    border-bottom-color: #d6d6d6!important;
}
#financialStatistics .scrollShow {
    overflow-y: scroll !important;
    height: 398px;
    overflow-x: hidden !important;
}
#financialStatistics .el-input__inner:focus {
    border: 2px solid rgba(0, 224, 218, 0.5) !important;
}
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
#financialStatistics ::-webkit-scrollbar {
    width: 10px; /*对垂直流动条有效*/
    height: 10px; /*对水平流动条有效*/
}
/*定义滚动条的轨道颜色、内阴影及圆角*/
#financialStatistics ::-webkit-scrollbar-track {
    /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
    background-color: rgba(51, 51, 51, 0.2);
    border-radius: 3px;
}
/*定义滑块颜色、内阴影及圆角*/
#financialStatistics ::-webkit-scrollbar-thumb {
    border-radius: 7px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(255, 255, 255, 0.8);
}
#financialStatistics .el-date-editor--daterange.el-input__inner {
    width: 100% !important;
}
#financialStatistics .el-date-editor .el-range-input {
    color: #333333;
    font-weight: 500;
}
#financialStatistics .el-date-editor .el-range__icon {
    color: #333333;
    font-weight: 500;
}
#financialStatistics .el-input__inner {
    border-bottom: none;
    /* border-top-left-radius: unset;
  border-bottom-left-radius: unset; */
}
#financialStatistics .el-input--mini .el-input__inner {
    padding-left: 30px;
    width: 257px;
    border: 1px solid rgba(51, 51, 51, 0.2);
    transition: 0.2s;
    letter-spacing: .7px;
}
#financialStatistics .el-range-editor.el-input__inner {
    padding: 5px 10px;
}
#financialStatistics .el-main {
    padding: 0px;
}
#financialStatistics .el-table th:nth-child(1) .cell {
    text-align: center;
}
#financialStatistics .el-table th > .cell {
    padding: 0px;
    line-height: 46px;
}
#financialStatistics .el-table .cell {
    padding: 0px;
}
#financialStatistics .el-table__body-wrapper {
    /* height: 398px; */
    /* overflow-y: scroll;
    overflow-x: hidden; */
    /* box-sizing: border-box; */
    /* border: 1px solid rgba(51, 51, 51, 0.2); */
}
#financialStatistics .el-table__body {
    /* height: 400px; */
    overflow: hidden;
}
#financialStatistics .el-table__header {
    border-bottom: 1px solid rgba(51, 51, 51, 0.2);
}
#financialStatistics .el-table th.is-leaf,
.el-table td {
    border-bottom: none;
}
#financialStatistics .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(0, 224, 218, 0.05) !important;
}
#financialStatistics .el-range-editor.is-active {
    border-color: rgba(51, 51, 51, 0.2);
}
#financialStatistics .el-table--fit {
    border: 1px solid rgba(51, 51, 51, 0.2);
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
}
</style>
<script>
import moment from 'moment'
import CsvExportor from 'csv-exportor'
import TotalSales from './TotalSalesEcharts.vue'
import TopSales from './TopSalesEcharts.vue'
moment.locale('en')
export default {
    components: {
        TotalSales,
        TopSales
    },
    data () {
        return {
            loading: false,
            search: '',
            ischoose: false,
            isLiBackColor: '',
            value6: '',
            daterange: 'daterange',
            tableData: [],
            total: '',
            // all
            totalData: [],
            topData: [],
            isShowScroll: false
        }
    },
    mounted () {
        setTimeout(() => {
            this.pickerStyle(0, true)
        }, 0)
        // 默认七天
        this.clickLiColor('0', 'week')
    },
    methods: {
        // 数据
        toolTipMoment (type, date) {
            if (type === 'beg') {
                return moment(date).format('MMM Do')
            }
            if (type === 'end') {
                return moment(date).format('ll')
            }
        },
        isScrollShowFunc (len) {
            if (len > 4) {
                this.$refs.dataTable.$el
                    .querySelector('.el-table__body-wrapper')
                    .classList.add('scrollShow')
            } else {
                this.$refs.dataTable.$el
                    .querySelector('.el-table__body-wrapper')
                    .classList.remove('scrollShow')
            }
        },
        increaseRateText ({ row }) {
            if (typeof row.increaseRate !== 'number') {
                return '--'
            } else {
                if (!isNaN(row.increaseRate)) {
                    if (row.increaseRate > 0 || row.increaseRate < 0) {
                        return `${row.increaseRate}%`
                    } else {
                        return '--'
                    }
                }
            }
        },
        increaseRateStyle ({ row }) {
            if (typeof row.increaseRate !== 'number') {
                return ''
            } else {
                if (!isNaN(row.increaseRate)) {
                    if (row.increaseRate > 0) {
                        return 'increaseRateClassPositive'
                    } else if (row.increaseRate < 0) {
                        return 'increaseRateClassNegative'
                    } else {
                        return ''
                    }
                }
            }
        },
        getAnalysisData (type, value, obj) {
            this.loading = true
            let urlPrivate, path
            if (type === '0') {
                let Public = `/developer/statics/list?`
                if (obj && value) {
                    let { key, val } = obj
                    if (value === 'sort') {
                        urlPrivate = `sortBy=${key}&sort=${val}`
                    } else if (value === 'data') {
                        urlPrivate = `beginDate=${key}&endDate=${val}`
                    } else {
                        urlPrivate = `${key}=${val}`
                    }
                    path = Public + urlPrivate
                }
            } else {
                let Public = `/developer/statics/chart?`
                if (obj && value) {
                    let { key, val } = obj
                    if (value === 'sort') {
                        urlPrivate = `sortBy=${key}&sort=${val}`
                    } else if (value === 'all' || value === 'top') {
                        urlPrivate = `type=${value}&beginDate=${key}&endDate=${val}`
                    } else {
                        urlPrivate = `${key}=${val}`
                    }
                    path = Public + urlPrivate
                }
            }
            this._api.request('get', path)
                .then(res => {
                    let data = res.data.data
                    if (res.status === 200) {
                        if (value === 'data') {
                            this.tableData = data.payload
                            this.total = data.query.total
                            this.isScrollShowFunc(data.payload.length)
                        } else if (value === 'all') {
                            this.totalData = data
                        } else {
                            this.topData = data
                        }
                        this.loading = false
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        clickLiColor (type, time) {
            let dateObj = this.computedDate(time)
            this.isLiBackColor = type
            this.pickerStyle(0, true)
            this.value6 = ''
            this.getAnalysisData('0', 'data', dateObj)
            this.getAnalysisData('1', 'top', dateObj)
            this.getAnalysisData('1', 'all', dateObj)
        },
        // 时间
        momentFunc (date, type) {
            if (!date) {
                return
            }
            if (type) {
                return moment(date).format('YYYY-MM-DD')
            }
            return moment(date).format('YYYY-MM-DD HH:mm:ss')
        },
        // 时间函数
        computedDate (type) {
            let val = this.momentFunc(new Date())
            let key
            if (type === 'week') {
                key = this.momentFunc(
                    new Date(new Date() - 6 * 24 * 3600 * 1000)
                )
                return { key, val }
            } else if (type === 'month') {
                key = this.momentFunc(
                    new Date(new Date() - 29 * 24 * 3600 * 1000)
                )
                return { key, val }
            } else {
                key = this.momentFunc(
                    new Date().setFullYear(new Date().getFullYear() - 1)
                )
                return { key, val }
            }
        },
        csvFunc () {
            let path = `/developer/statics/list?display=csv`
            this._api.request('get', path)
                .then(res => {
                    // console.log(res.data)
                    // let str = res.data + `\n"2019-01-22","2019-01-29",,"application",0,0,0,null,"-"`
                    let strArr = res.data
                        .replace(/"/gi, '')
                        .replace(/\s+|&nbsp;/gi, ',')
                        .split(',')
                    let length = parseInt(strArr.length / 9)
                    let dataArr = []
                    for (let i = 0; i < length; i++) {
                        dataArr.push(strArr.slice(i * 9, (i + 1) * 9))
                    }
                    // dataArr.push(['2019-01-22', '2019-01-29', '', 'application', '0', '0', '0', 'null', '-'])
                    // console.log(dataArr, str)
                    CsvExportor.downloadCsv(dataArr, {}, '财务分析.csv')
                })
                .catch(error => {
                    console.log(error)
                })
        },
        // 点击搜索
        searchClick () {
            if (!this.search) {
                return
            }
            this.serachFunc('0', null)
            this.serachFunc('1', 'all')
            this.serachFunc('1', 'top')
        },
        // 搜索函数
        serachFunc (type, val) {
            let urlPrivate, path
            if (type === '0') {
                let Public = `/developer/statics/list?`
                urlPrivate = `keyword=${this.search}`
                path = Public + urlPrivate
            } else {
                let Public = `/developer/statics/chart?`
                urlPrivate = `type=${val}&keyword=${this.search}`
                path = Public + urlPrivate
            }
            this._api.request('get', path)
                .then(res => {
                    let data = res.data.data.payload
                    if (val === 'top') {
                        this.topData = data
                    }
                    if (val === 'all') {
                        this.totalData = data
                    }
                    if (!val) {
                        this.tableData = data
                        let len = this.tableData.length
                        this.total = len
                        this.isScrollShowFunc(len)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        outputType (type) {
            if (type === '1') {
                this.getPdf('#app', '财务统计')
            } else {
                this.csvFunc()
            }
        },
        // pickerDate
        pickerFunc () {
            this.ischoose = true
            this.isLiBackColor = null
            this.elIconDate = 'el-icon-date'
        },
        blurFunc () {
            if (!this.value6) {
                this.ischoose = false
                this.elIconDate = ' '
            } else {
                let beginDate, endDate
                for (let i = 0; i < this.value6.length; i++) {
                    if (i === 0) {
                        beginDate = this.momentFunc(this.value6[i])
                    } else {
                        endDate = this.momentFunc(this.value6[i])
                    }
                }
                let dateObj = { beginDate, endDate }
                this.getAnalysisData('0', 'data', dateObj)
                this.getAnalysisData('1', 'top', dateObj)
                this.getAnalysisData('1', 'all', dateObj)
                // this.getData(1, { beginDate, endDate });
            }
        },
        pickerStyle (type, flag) {
            let dom = this.$refs.picker.$el
            let childNodes = dom.childNodes
            let display, weight, color, backColor
            color = '#333'
            if (type === 0) {
                display = 'none'
                if (childNodes.length < 6) {
                    let span = document.createElement('span')
                    span.innerText = '自訂範圍'
                    span.style.marginLeft = '11px'
                    dom.appendChild(span)
                }
                if (flag) {
                    weight = '300'
                } else {
                    weight = '500'
                }
                childNodes[5].style.color = color
                childNodes[5].style.fontWeight = weight
                childNodes[5].style.lineHeight = '38px'
                childNodes[5].style.display = 'block'
            } else {
                display = 'block'
                weight = '300'
                childNodes[2].style.width = '10px'
                if (childNodes.length === 6) {
                    childNodes[5].style.display = 'none'
                }
                childNodes[5].style.fontWeight = weight
            }
            for (let i = 0; i < 5; i++) {
                childNodes[i].style.display = display
            }
            dom.style.backgroundColor = backColor
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'line-height: 47px;padding: 0px;color: #333333;'
            }
        }
    },
    watch: {
        search () {
            !this.search && this.clickLiColor('0', 'week')
            this.searchClick()
            return this.search
        }
    },
    beforeUpdate () {
        // 切换日期选择器的样式
        if (!this.value6) {
            this.ischoose = false
            this.elIconDate = ' '
            this.pickerStyle(0)
        } else if (this.value6) {
            this.ischoose = true
            this.elIconDate = 'el-icon-date'
            this.pickerStyle(1)
        }
        if (this.isLiBackColor) {
            this.pickerStyle(0, true)
        }
    }
}
</script>
